/**
 * Federal fiscal year runs Oct 1 – Sep 30, named by the year it ends in.
 */
export const getFiscalYear = (month: number, calendarYear: number): number => {
  if (month >= 10) {
    return calendarYear + 1
  }
  return calendarYear
}

export const getCurrentFiscalYear = (date: Date = new Date()): number => {
  return getFiscalYear(date.getMonth() + 1, date.getFullYear())
}
